<div class="add-docs-modal-wrapper">
  <div class="add-docs-modal-container" fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="space-between">
      <h2>{{ 'CALC_PAGE.UPLOAD_DOCUMENTS_FOR_ORDER' | translate }}</h2>
      <i class="fa fa-times" (click)="dialogRef.close()"></i>
    </div>
    <app-order-documents-upload [orderID]="order.id" [fileTypes]="fileTypes" (onFileUpload)="saveOrder()"></app-order-documents-upload>
  </div>
</div>

